import {createSvgIcon} from './utils'

export default createSvgIcon(
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M10.5 0C13.2847 3.4539e-05 15.9557 1.10606 17.9248 3.0752C19.8938 5.04431 21 7.71528 21 10.5C21 13.2847 19.8937 15.9557 17.9248 17.9248C15.9557 19.8939 13.2847 21 10.5 21C7.71526 21 5.0443 19.894 3.0752 17.9248C1.10618 15.9557 0 13.2848 0 10.5C4.94373e-05 7.71524 1.10613 5.04432 3.0752 3.0752C5.0443 1.10606 7.71528 0 10.5 0ZM9.1875 11.0439L13.5762 15.0283L14.9541 13.6504L11.8125 9.95703L11.5498 3.15039L9.4502 3.14258L9.1875 11.0439Z"
  />,
  'TimePinBadge',
)
